import React from 'react';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import ChangeRequestAddEdit from './change-request-add-edit';

const { CHANGEREQUEST_ADD_EDIT } = MODAL_TYPES;

const ChangeRequestModals = () => {
  return (
    <>
      <ChangeRequestAddEdit modalId={CHANGEREQUEST_ADD_EDIT} />
    </>
  );
};

export default ChangeRequestModals;
